import Section from './FinestWhitesNeutralsSection'
import isEmpty from './FinestWhitesNeutralsIsEmpty'

export default { Section, isEmpty }
